import { useState, useEffect } from 'react';
import { fetchContactInformation } from '@/api/resort/static';
import { IContactInformation } from '@/api/resort/types';

export const useContactInformation = (uuid:string) => {
  const [contactInfo, setContactInfo] = useState<IContactInformation | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchContactInformation(uuid);
      setContactInfo(data);
    };
    fetchData().catch(() => {});
  }, [uuid]);

  return contactInfo;
};
